export default __webpack_public_path__ + "a0af72d22afe2a18a9cf9b22ae2c2b09.svg";